import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { LifePageContentTitle } from '../common/life/lifePageContentTitle';
import { translate } from  '../../common/translation/translate';
import { withScreenSize } from '../common/utilities/withScreenSize.jsx';
import { DisplayAdWidget } from '../ads/displayAdWidget.jsx';
import { smallMediaQuery, mediumMediaQuery, largeMediaQuery } from '../../common/utilities/sizeHelpers';
import { SnowSkiMap } from './snowSkiMap';
import { ResortCard } from './resortCard';
import { parseAndFormatISO8601DateStr } from '../../common/utilities/dateTimeUtils';
import { DisplayAdUnit } from '../../containers/ads/displayAdUnitContainer';

const showResortView = true;
const noValuePlaceholder = '--';

// eslint-disable-next-line react/display-name
export const SnowSkiPageView = withScreenSize(memo(({
    resortArray,
    userLatitude,
    userLongitude,
    isDesktop,
    isMobile,
    forecastBaseUrl,
    contentMgmtBaseUrl,
    forecastIconResourceList,
    forecastIconSize,
    forecastIconSet,
    authId,
    secret,
    obsBaseUrl,
    stdParameters,
    user,
    getHourlyForecastByLatLon,
    getDailyForecastByLatLon,
    getCurrentStationObsByLatLon,
    tempUnit
}) => {
    return (
        <>
            {!isDesktop
                && <MobileBannerAd>
                    <DisplayAdUnit
                        width={320}
                        height={50}
                        slotId={'life_snowski_mobile_top_banner_x83'}
                    />
                </MobileBannerAd>
            }
            <LifePageContentTitle pageTitle={translate('snowSki')} showTitleAsH1={true} />
            <PageContainer>
                <CardsContainer>
                    <MapContainer>
                        <SnowSkiMap
                            latitude={userLatitude}
                            longitude={userLongitude}
                        />
                    </MapContainer>
                    <CardsList>
                        {resortArray?.map((resort, i) => {
                            const resortReport = resort?.ResortData?.snowreport?.report;
                            return (
                                <>
                                    <ResortCard
                                        key={resort.ResortData.resortId}
                                        index={resortArray.indexOf(resort)}
                                        resortName={resort?.ResortData?.resortName}
                                        baseSnow={resortReport?.snowQuality?.onSlope?.middleDepth || noValuePlaceholder}
                                        newSnow={resortReport?.latestSnow || noValuePlaceholder}
                                        reported={
                                            resortReport?.latestSnowDate
                                                ? parseAndFormatISO8601DateStr(resortReport?.latestSnowDate, 'MM/dd', false)
                                                : noValuePlaceholder
                                        }
                                        openStatusFlag={resortReport?.openflag}
                                        openStatus={resortReport?.openflagname || noValuePlaceholder}
                                        totalLifts={resort?.ResortData?.info?.lifts?.numLifts || noValuePlaceholder}
                                        openLifts={resortReport?.liftsReport?.liftsOpen || noValuePlaceholder}
                                        snowCondition={resortReport?.snowQuality?.onSlope?.surfaceTop || noValuePlaceholder}
                                        forecastBaseUrl={forecastBaseUrl}
                                        contentMgmtBaseUrl={contentMgmtBaseUrl}
                                        forecastIconResourceList={forecastIconResourceList}
                                        forecastIconSize={forecastIconSize}
                                        forecastIconSet={forecastIconSet}
                                        resortLatitude={resort.Latitude}
                                        resortLongitude={resort.Longitude}
                                        authId={authId}
                                        secret={secret}
                                        obsBaseUrl={obsBaseUrl}
                                        stdParameters={stdParameters}
                                        user={user}
                                        getHourlyForecastByLatLon={getHourlyForecastByLatLon}
                                        getDailyForecastByLatLon={getDailyForecastByLatLon}
                                        getCurrentStationObsByLatLon={getCurrentStationObsByLatLon}
                                        showResortView={showResortView}
                                        tempUnit={tempUnit}
                                    />
                                    {i === 2 && isMobile && <StoriesAdWrapper>
                                        <DisplayAdUnit 
                                            slotId={'life_snowski_mobile_stories_x11'}
                                            height={250}
                                            width={300}
                                        />
                                    </StoriesAdWrapper>}
                                </>
                                
                            );
                        })}
                    </CardsList>
                </CardsContainer>
                {isDesktop 
                    && <AdContainer>
                        <DisplayAdUnit
                            slotId={'life_snowski-top_right_x16'}
                            height={600}
                            width={300}
                        />
                    </AdContainer>
                }
            </PageContainer>
        </>
    );
}));

SnowSkiPageView.displayName = 'SnowSkiPageView';
SnowSkiPageView.propTypes = {
    resortArray: PropTypes.array,
    authId: PropTypes.string,
    secret: PropTypes.string,
    stdParameters: PropTypes.object,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    openNavMenu: PropTypes.func,
    isDesktop: PropTypes.any,
    forecastBaseUrl: PropTypes.string,
    contentMgmtBaseUrl: PropTypes.string,
    forecastIconResourceList: PropTypes.string,
    forecastIconSize: PropTypes.string,
    forecastIconSet: PropTypes.string,
    obsBaseUrl: PropTypes.string,
    user: PropTypes.object,
    getHourlyForecastByLatLon: PropTypes.func,
    getDailyForecastByLatLon: PropTypes.func,
    getCurrentStationObsByLatLon: PropTypes.func
};

const PageContainer = styled.div`
    display: flex;
    flex-direction: row;
    @media ${largeMediaQuery} {
        margin-right: 5px;
    }
`;

const MobileBannerAd = styled.div`
    margin-bottom: 20px;
`;

const MapContainer = styled.div`
    text-decoration: none;
    display: block;
    margin-top: 10px;
`;

const CardsContainer = styled.div`
    @media ${largeMediaQuery} {
        width: calc(100% - 316px);
    }

    @media ${mediumMediaQuery} {
        margin-bottom: 10px;
    }
`;

const CardsList = styled.ul`
    padding-left: 0;
    white-space: normal;

    @media ${smallMediaQuery} {
        margin: 2px 0 4px 0;
    }
`;

const AdContainer = styled.div`
    padding: 10px 0 0 16px;
    float: right;
`;

const StoriesAdWrapper = styled.div`
    margin: 20px 0 10px 0;
`;
